import { useEffect } from 'react';

export const useScrollToTop = <T = string>(dependency?: T) => {
    useEffect(() => {
        document.body.scrollIntoView();
    }, [dependency]);
};
